import { ColorTokens } from '@/theme';

/** Nav label → the id of the section it jumps to. */
export const NAV: [string, string][] = [
  ['Collaborate', 'lp-handoff'],
  ['Versions', 'lp-versions'],
  ['Boards', 'lp-boards'],
  ['Questions', 'lp-faq'],
];

/**
 * The header sits over the top of a jumped-to heading otherwise. Applied to
 * every anchor target rather than to a scroll container, so it holds regardless
 * of which element is actually doing the scrolling.
 */
export const ANCHOR = { scrollMarginTop: '80px' };

export const WORKS_WITH: [string, string][] = [
  ['Ableton', 'Ableton'],
  ['LogicPro', 'Logic Pro'],
  ['ProTools', 'Pro Tools'],
  ['FLStudio', 'FL Studio'],
  ['Cubase', 'Cubase'],
  ['Reaper', 'Reaper'],
  ['StudioOne', 'Studio One'],
];

export const HOW_STEPS: [string, string][] = [
  [
    'Create a checkpoint',
    'Add a commit message and upload the files that changed.',
  ],
  [
    'Inspect any version',
    'Expand its history to see files that were created, updated or deleted.',
  ],
  [
    'Go back when you need to',
    'Download an older copy or sync it back after confirming local changes.',
  ],
];

export const COLLAB_POINTS: [string, string][] = [
  ['Custom stages', 'add, rename, delete and reorder board columns.'],
  ['Project cards', 'drag work between stages and open project details.'],
  ['Shared boards', 'invite other StudioVault members to work with you.'],
  [
    'Fast filtering',
    'find cards by project name or the person who added them.',
  ],
];

/**
 * Colours are named rather than resolved here so the whole page can follow the
 * light/dark toggle — the literal is looked up per mode at render time.
 */
type AccentKey = Extract<keyof ColorTokens, 'accentText' | 'cyan' | 'green'>;

export const FEATURES: {
  rubric: string;
  color: AccentKey;
  title: string;
  body: string;
}[] = [
  {
    rubric: '01 / VERSIONS',
    color: 'accentText',
    title: 'Go back to any checkpoint',
    body: 'Inspect file-level changes, download an older version or sync it back to your linked project folder.',
  },
  {
    rubric: '02 / SYNC',
    color: 'cyan',
    title: 'Upload only what changed',
    body: 'Compare the local folder with the cloud version, then upload new and updated files directly to storage.',
  },
  {
    rubric: '03 / BOARDS',
    color: 'green',
    title: 'See every project in motion',
    body: 'Build a Kanban workflow, add projects as cards and drag them from the first idea to the final master.',
  },
  {
    rubric: '04 / TEAM',
    color: 'accentText',
    title: 'Unlimited collaborators',
    body: 'Add as many collaborators as you want. Share projects with collaborators or read-only members, and invite your team to shared boards.',
  },
];
